// Contact form controller. Mirrors wholesale-form.js — POSTs the form
// to wp-admin/admin-ajax.php (action: sentiments_contact_form). The
// server-side handler in functions.php hybridises submission to CPT +
// Klaviyo event + best-effort wp_mail to support@sentimentsindia.com.
// AJAX URL + nonce localized into window.sentimentsContact.

export function initContactForm() {
	const form = document.querySelector('[data-contact-form]');
	if (!form) return;

	const submit = form.querySelector('.sentiments-contact-page__submit');
	const status = form.querySelector('.sentiments-contact-page__status');

	const setStatus = (state, message) => {
		if (!status) return;
		status.dataset.state = state;
		status.textContent = message;
	};

	const setSubmitting = (isSubmitting) => {
		if (!submit) return;
		if (isSubmitting) {
			submit.dataset.state = 'loading';
			submit.setAttribute('aria-busy', 'true');
		} else {
			delete submit.dataset.state;
			submit.removeAttribute('aria-busy');
		}
	};

	form.addEventListener('submit', async (e) => {
		e.preventDefault();
		setStatus('', '');

		if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
			return;
		}

		const config = window.sentimentsContact;
		if (!config || !config.ajax) {
			setStatus('error', 'Form is offline — please email info@sentimentsindia.com instead.');
			return;
		}

		const data = new FormData(form);
		data.append('action', 'sentiments_contact_form');
		data.append('nonce', config.nonce);

		setSubmitting(true);

		try {
			const response = await fetch(config.ajax, {
				method: 'POST',
				body: data,
				credentials: 'same-origin',
			});

			let payload;
			try { payload = await response.json(); } catch { payload = {}; }

			if (response.ok && payload && payload.ok) {
				setStatus('success', payload.message || 'Thank you — we will be in touch shortly.');
				form.reset();
			} else {
				setStatus('error', (payload && payload.message) || 'Something went wrong. Please try again.');
			}
		} catch (err) {
			setStatus('error', 'Could not reach our server. Please try again in a moment.');
		} finally {
			setSubmitting(false);
		}
	});
}
